export enum OfficeCalendarError {
	NONE,
	GENERAL_FAIL,
	TIME_NO_LONGER_AVAIL,
	NO_OPEN_TIME,
	OUT_OF_RANGE_PAST_DATE,
	OUT_OF_RANGE_FUTURE_DATE,
}
